export default "__VITE_ASSET__M52f4Ep6__"